module.exports = __webpack_public_path__ + "static/media/close-black.b7120133.svg";